import { GET_BANNER } from "../../actions/type";
export default function access(state={},action){
    switch(action.type){
        case GET_BANNER:
            return action.payload;
        default:
            return state
    }
}